import defaultCommonHelmet from './common-helmet.json';

export default function getCommonHelmetJSON(applicationName) {
  const manifest = {
    rel: 'manifest',
    href: '/manifest.json'
  };

  switch (applicationName) {
    case 'aerial-dweb':
    case 'aerial-seo-dweb':
      manifest.href = '/webmanifest-desktop.json';
      break;
    case 'aerial-mweb-lite':
    case 'aerial-seo-mweb':
    case 'aerial-mweb':
      manifest.href = '/webmanifest-mobile.json';
  }

  return {
    ...defaultCommonHelmet,
    link: [...defaultCommonHelmet.link, manifest]
  };
}
